import * as angular from 'angular';

"use strict";

angular.module('AdvancedReportsModule', []);

export default 'AdvancedReportsModule';